import * as z from 'zod/v4';
import { HttpKeys } from 'fastify/types/utils';
import { UnauthorizedErrorResponse } from '../schemas/utils/utils.schema';

type ResponseSchema = Record<HttpKeys, z.ZodType>;

export type ZodApiSchema = {
  body?: z.ZodType;
  querystring?: z.ZodType;
  headers?: z.ZodType;
  response: Partial<ResponseSchema>;
  params?: z.ZodType;
};

export const validationSchema = <S extends ZodApiSchema>(schema: S): S => {
  if (process.env.NODE_ENV === 'PROD') {
    return {
      ...schema,
      response: undefined,
    } as S;
  }
  return {
    ...schema,
    response: {
      ...schema.response,
      // Handles cases where the input request is invalid
      400: z.object({
        errorMessage: z.string(),
      }),
      401: UnauthorizedErrorResponse,
      403: z.object({
        errorMessage: z.string(),
      }),
    },
  };
};
